export async function apiClient(
  authToken: string | undefined,
  endpoint: RequestInfo,
  options?: RequestInit,
  responseType?: "JSON" | "BLOB" | undefined
) {
  const { body, ...customConfig } = options ?? {};
  const isFormData = body instanceof FormData;

  const headers: HeadersInit = isFormData
    ? {}
    : { "Content-Type": "application/json" };

  const impersonationSessionId = sessionStorage.getItem(
    "impersonationSessionId"
  );

  const config: RequestInit = {
    method: body ? "POST" : "GET",
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
      Authorization: `Bearer ${authToken}`,
      ...(impersonationSessionId
        ? { "X-Impersonation-Session": impersonationSessionId }
        : {}),
    } as HeadersInit,
  };

  if (body) {
    config.body = body;
  }

  let data = undefined;
  try {
    const response = await window.fetch(
      `${process.env.REACT_APP_API_URL}/${endpoint}`,
      config
    );
    if (response.ok) {
      if (response.status === 204) {
        data = null;
      } else if (responseType === undefined || responseType === "JSON") {
        data = await response.json();
      } else if (responseType === "BLOB") {
        data = await response.blob();
      }
      return data;
    }
    let errorMessage = response.statusText;
    try {
      const errorBody = await response.json();
      if (
        errorBody &&
        typeof errorBody.message === "string" &&
        errorBody.message.trim()
      ) {
        errorMessage = errorBody.message;
      }
    } catch {
      // Keep statusText when the error body is not JSON.
    }
    throw new Error(errorMessage);
  } catch (err: any) {
    // fetch() rejects with AbortError when the caller passes an AbortSignal and aborts.
    // Map to a sentinel so callers can ignore superseded requests without treating them as failures.
    if (err?.name === "AbortError") {
      return Promise.reject({ aborted: true });
    }
    return Promise.reject(err && err.message ? err.message : data);
  }
}
